<div class="cw-layout">
  <app-workbench-header></app-workbench-header>

  <main class="cw-layout__main" aria-labelledby="open-jobs-title">
    <header class="cw-page-head">
      <div>
        <nav class="cw-breadcrumb" [attr.aria-label]="'open_jobs_summary_title' | translate">
          <a routerLink="/dashboard">{{ "resource_admin_dashboard_title" | translate }}</a>
          <span aria-hidden="true">/</span>
          <span aria-current="page">{{ "open_jobs_summary_title" | translate }}</span>
        </nav>
        <h1 class="cw-page-head__title" id="open-jobs-title">{{ "open_jobs_summary_title" | translate }}</h1>
      </div>
      <div class="cw-thinksafe">
        <img class="cw-thinksafe__logo" src="/assets/thinksafe-logo.png" alt="ThinkSafe" />
        <span class="cw-thinksafe__link">Browse Health &amp; Safety Documents</span>
      </div>
    </header>

    <section class="cw-filters" [attr.aria-label]="'open_jobs_summary_filters' | translate">
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="site-name">{{ "open_jobs_summary_filter_site" | translate }}</label>
        <input class="cw-field__control" id="site-name" type="search" [(ngModel)]="siteName"
               [placeholder]="'open_jobs_summary_site_name' | translate" />
      </div>
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="brand-name">{{ "open_jobs_summary_filter_brand" | translate }}</label>
        <select class="cw-field__control" id="brand-name" [(ngModel)]="brandName">
          <option value="">{{ "open_jobs_summary_show_all" | translate }}</option>
          @for (brand of brands; track brand) {
            <option [value]="brand">{{ brand }}</option>
          }
        </select>
      </div>
    </section>

    @if (hasLoadError) {
      <div class="cw-state cw-state--error cw-card" role="alert">{{ "open_jobs_summary_load_error" | translate }}</div>
    } @else if (!hasLoaded) {
      <div role="status" [attr.aria-label]="'signin_lbl_loading_jobs' | translate">
        <app-skeleton layout="table" [rows]="5" [columns]="7"></app-skeleton>
      </div>
    } @else {
      <section class="cw-table-card cw-card" [attr.aria-label]="'open_jobs_summary_by_site' | translate">
        <div class="cw-table-card__scroll">
          <table class="cw-table" role="table">
            <thead role="rowgroup">
              <tr role="row">
                <th class="cw-table__head-cell cw-table__site" scope="col" role="columnheader">{{ "open_jobs_summary_site" | translate }}</th>
                <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "open_jobs_summary_brand" | translate }}</th>
                @for (column of jobColumns; track column.countKey) {
                  <th class="cw-table__head-cell cw-table__head-cell--num" scope="col" role="columnheader">{{ column.label | translate }}</th>
                }
              </tr>
            </thead>
            <tbody role="rowgroup">
              @for (summary of filteredSummaries; track summary.site?.id) {
                <tr class="cw-table__row" role="row">
                  <th class="cw-table__cell cw-table__cell--lead" scope="row" role="rowheader">
                    {{ summary.site?.name || ("open_jobs_summary_unknown_site" | translate) }}
                  </th>
                  <td class="cw-table__cell" [attr.data-label]="'open_jobs_summary_brand' | translate" role="cell">
                    <span>{{ summary.brand?.name || ("open_jobs_summary_not_available" | translate) }}</span>
                  </td>
                  @for (column of jobColumns; track column.countKey) {
                    <td class="cw-table__cell cw-table__cell--num" [attr.data-label]="column.label | translate" role="cell">
                      <button type="button" class="cw-count-link"
                              [disabled]="summary[column.countKey] === 0"
                              [attr.aria-label]="(column.label | translate) + ': ' + summary[column.countKey]"
                              (click)="openJobList(summary, column.type, summary[column.countKey])">
                        {{ summary[column.countKey] }}
                      </button>
                    </td>
                  }
                </tr>
              } @empty {
                <tr role="row">
                  <td class="cw-table__empty" colspan="7" role="cell">{{ "open_jobs_summary_empty" | translate }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </section>
    }
  </main>

  <app-workbench-footer></app-workbench-footer>
</div>
